module.exports = __webpack_public_path__ + "static/media/RP-78.671f041e.pdf";